import { Route } from '@angular/router'
import { publicGuard } from '@mattrika/benefit-core'
import { PageLayout } from '../../layouts/page-layout.enum'
import { setLayout } from '../../layouts/set-layout.resolver'

export const PublicRoutes: Route[] = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'home',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('./client-home/client-home.component').then(
                (c) => c.ClientHomeComponent,
            ),
    },
    {
        path: 'offer/:id',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('../client/page-offer-detail/page-offer-detail.component').then(
                (c) => c.PageOfferDetailComponent,
            ),
    },
    {
        path: 'help-center',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('./page-help-center/page-help-center.component').then(
                (c) => c.PageHelpCenterComponent,
            ),
    },
    {
        path: 'faqs',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('./page-faqs/page-faqs.component').then(
                (c) => c.PageFaqsComponent,
            ),
    },
    {
        path: 'terms',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('./page-terms/page-terms.component').then(
                (c) => c.PageTermsComponent,
            ),
    },
    {
        path: 'privacy',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('./page-privacy/page-privacy.component').then(
                (c) => c.PagePrivacyComponent,
            ),
    },
    {
        path: 'contact',
        resolve: { layout: setLayout(PageLayout.Client) },
        loadComponent: () =>
            import('./page-contact/page-contact.component').then(
                (c) => c.PageContactComponent,
            ),
    },
    {
        path: 'login',
        canActivate: [publicGuard()],
        loadComponent: () =>
            import('@mattrika/benefit-core').then((m) => m.PageLoginComponent),
        resolve: { layout: setLayout(PageLayout.Blank) },
    },
    {
        path: 'register',
        canActivate: [publicGuard()],
        loadComponent: () =>
            import('@mattrika/benefit-core').then(
                (m) => m.PageRegisterComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Blank) },
    },
    {
        path: 'forgot-password',
        canActivate: [publicGuard()],
        loadComponent: () =>
            import('@mattrika/benefit-core').then(
                (m) => m.PageForgotPasswordComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Blank) },
    },
    {
        path: 'verify-email/:token',
        canActivate: [publicGuard()],
        loadComponent: () =>
            import('@mattrika/benefit-core').then(
                (m) => m.PageVerifyEmailComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Blank) },
    },
]
